import { Route, Link, Routes, Outlet } from "react-router-dom";
import { toAbsoluteUrl } from "../../helpers/assetHelper";
import { Error404 } from "./Error404";
import { Error500 } from "./Error500";

const ErrorsLayout = () => {
  return (
    <div className="flex min-h-screen flex-col">
      <div
        className="flex flex-1 flex-col bg-contain bg-center bg-bottom bg-no-repeat bg-fixed"
        style={{
          backgroundImage: `url('${toAbsoluteUrl(
            "/media/illustrations/progress-hd.png"
          )}')`,
        }}
      >
        <div className="flex flex-1 flex-col p-10 text-center lg:py-20">
          <a href="/dashboard" className="mb-10 lg:pt-20">
            <img
              alt="Logo"
              src={toAbsoluteUrl("/logo.svg")}
              className="mb-5 h-[50px]"
            />
          </a>
          <div className="mb-10 lg:pt-10">
            <Outlet />
            <div className="text-center">
              <Link to="/" className="inline-flex items-center justify-center rounded-control border-0 px-4 py-2 font-semibold transition min-h-12 px-5 text-base bg-brand text-brand-foreground hover:brightness-95 font-bold">
                Go to homepage
              </Link>
            </div>
          </div>
          <div
            className="min-h-[100px] shrink-0 bg-contain bg-center bg-bottom bg-no-repeat lg:min-h-[350px]"
            style={{
              backgroundImage: `url('${toAbsoluteUrl(
                "/media/illustrations/sketchy-1/17.png"
              )}')`,
            }}
          ></div>
        </div>

        <div className="flex shrink-0 items-center justify-center p-10">
          <div className="flex items-center font-semibold text-sm">
            <a
              href="https://keenthemes.com"
              className="text-muted hover:text-brand px-2"
            >
              About
            </a>
            <a
              href="mailto:support@keenthemes.com"
              className="text-muted hover:text-brand px-2"
            >
              Contact
            </a>
            <a
              href="https://1.envato.market/EA4JP"
              className="text-muted hover:text-brand px-2"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

const ErrorsPage = () => (
  <Routes>
    <Route element={<ErrorsLayout />}>
      <Route path="404" element={<Error404 />} />
      <Route path="500" element={<Error500 />} />
      <Route index element={<Error404 />} />
    </Route>
  </Routes>
);

export { ErrorsPage };
